import { Expose } from "class-transformer";

export class ReorderPlanningBoardProjectsDto {
  @Expose()
  planningBoardProjectIds: string[];
}
